import { storyblokEditable, renderRichText } from "@storyblok/react"
import { Button } from "../../ui/button"
import { motion } from "framer-motion"

export default function WhyConcierge({ blok }: any) {
  const toPlain = (rich: any) =>
    (renderRichText(rich || { content: [] }) || "")
      .toString()
      .replace(/<[^>]+>/g, "")
      .replace(/\s+/g, " ")
      .trim()

  const ctaText = toPlain(blok?.ctaText)

  return (
    <section
      {...storyblokEditable(blok)}
      className="bg-white py-24 md:py-28 px-6 md:px-12"
    >
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <div
            className="font-['BeausiteClassic'] font-bold text-[24px] md:text-[32px] text-gray-900"
            dangerouslySetInnerHTML={{
              __html: renderRichText(blok.heading || { content: [] }) || "",
            }}
          />
          <span className="mt-3 mx-auto block h-[3px] w-16 rounded-full bg-gradient-to-r from-[#4750F5] to-[#8BA3FF]" />
        </div>

        <motion.div
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.45, ease: "easeOut" }}
          className="relative rounded-3xl border border-gray-100 bg-white/80 backdrop-blur-sm shadow-[0_8px_32px_rgba(27,31,59,0.08)]"
        >
          <div className="absolute left-0 top-6 bottom-6 w-2 rounded-full bg-gradient-to-b from-[#4750F5] to-[#8BA3FF]" />

          <div className="px-6 md:px-12 py-10 md:py-12">
            <div
              className="font-['BeausiteClassic'] text-base md:text-lg text-gray-700 leading-relaxed max-w-3xl"
              dangerouslySetInnerHTML={{
                __html: renderRichText(blok.blurb || { content: [] }) || "",
              }}
            />

            {blok?.subHeading?.content?.length ? (
              <div
                className="font-['BeausiteClassic'] text-base md:text-lg text-gray-700 mt-6"
                dangerouslySetInnerHTML={{
                  __html:
                    renderRichText(blok.subHeading || { content: [] }) || "",
                }}
              />
            ) : null}
            {ctaText && (
              <div className="mt-8">
                <Button asChild variant="default" size="lg">
                  <a
                    href={
                      blok?.ctaLink?.url || blok?.ctaLink?.cached_url || "#"
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {ctaText}
                  </a>
                </Button>
              </div>
            )}
          </div>
        </motion.div>
      </div>
    </section>
  )
}
